import CarouselOverlay from './carousel-overlay'

export default CarouselOverlay
